import React from "react";


const PhotoGallery = () => {
  const galleryImages = [
    "assets/img/gallery/1.jpg",
    "assets/img/gallery/2.jpg",
    "assets/img/gallery/3.jpg",
    "assets/img/gallery/4.jpg",
    "assets/img/gallery/5.jpg",
    "assets/img/gallery/6.jpg",
    "assets/img/gallery/7.jpg",
    "assets/img/gallery/8.jpg",
    "assets/img/gallery/9.jpg",
    "assets/img/gallery/10.jpg",
    "assets/img/gallery/11.jpg",
    "assets/img/gallery/12.jpg",
    "assets/img/gallery/13.jpg",
    "assets/img/gallery/14.jpg",
    "assets/img/gallery/15.jpg",
    "assets/img/gallery/16.jpg",
    "assets/img/gallery/17.jpg",
    "assets/img/gallery/18.jpg",
    "assets/img/gallery/19.jpg",
    
  ];

  return (
    <div className="overflow-hidden space">
      <div className="container">
        <div className="row gy-30 gx-30 filter-active">
          {galleryImages.map((image, index) => (
            <div
              className="col-md-6 col-xxl-auto col-lg-4 filter-item"
              key={index}
            >
              <div className="gallery-card">
                <div className="gallery-img">
                  <img src={image} alt={`gallery image ${index + 1}`} />
                  <a href={image} className="icon-btn popup-image">
                    <i className="fas fa-eye"></i>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PhotoGallery;
